import type { PhotoItemDto } from '@customTypes/types';

export const isPhotoItemDto = (obj: unknown): obj is PhotoItemDto =>
  (obj as PhotoItemDto).filePath !== undefined;
